/**
 * Loading spinner matching AngularJS Bootstrap theme
 */

export interface UiLoaderProps {
  /** Inline loader (default) or full-width bar */
  variant?: 'spinner' | 'bar';
  /** Size of spinner */
  size?: 'sm' | 'md' | 'lg';
  /** Additional classes */
  className?: string;
}

export const UiLoader = ({ variant = 'spinner', size = 'md', className = '' }: UiLoaderProps) => {
  if (variant === 'bar') {
    return (
      <div className='h-1 overflow-hidden rounded-t bg-angular-bg-light'>
        <div className='h-full w-full animate-pulse bg-angular-blue' />
      </div>
    );
  }

  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-6 w-6 border-2',
    lg: 'h-8 w-8 border-[3px]',
  };

  return (
    <span
      className={`inline-block animate-spin rounded-full border-angular-border border-t-angular-blue ${sizeClasses[size]} ${className}`}
      aria-hidden='true'
    />
  );
};
